import React from 'react';
import moment from "moment";

export default function({utcTimestamp, format}){
    let time = moment.utc(utcTimestamp).toDate();
    return (
        <span>{moment(time).local().format(format)}</span>
    )
}